<template>
  <v-dialog v-model="DIALOG_ATIVO" persistent max-width="800" content-class="bra-20" transition="dialog-top-transition">
    <v-card>
      <v-card-title class="pt-3 pb-3">
        <div>
          <slot name="titulo-lado-esquerdo">
            <p class="ma-0 font-21">Filtragem de produtos</p>
            <p class="ma-0 font-12 mt-n3 font-weight-regular text-gray-800">Combine os filtros para visualização dos produtos</p>
          </slot>
        </div>

        <v-spacer />

        <v-btn class="ml-n2" color="#000" icon @click="DIALOG_ATIVO = ! DIALOG_ATIVO">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <DivisorComLegenda legenda="Filtros gerais (lista de produtos, indicadores e carrinho)" class="mb-4" />

        <BlocoFiltrosPrincipais
          :filtros="filtros"
          @processamento:finalizado="selecionarGrupoComprasUsuario"
        />

        <DivisorComLegenda legenda="Filtros aplicados somente na lista de produtos" class="mb-4 mt-2" />

        <div class="d-flex">
          <div class="pb-3 pr-2 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Status compra</div>

            <FiltrosAutocomplete
              v-model="filtros.status_compra"
              :items="selects.status_compra"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
            >
              <template #prepend-inner v-if="filtros.status_compra.length === 0">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>

          <div class="pb-3 pl-1 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Status produto</div>

            <FiltrosAutocomplete
              v-model="filtros.status_produto"
              :items="selects.status_produto"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
            >
              <template #prepend-inner v-if="filtros.status_produto.length === 0">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>
        </div>

        <div class="d-flex">
          <div class="pb-3 pr-2 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Histogramas</div>

            <FiltrosAutocomplete
              v-model="filtros.histogramas"
              :items="selects.histogramas"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
            >
              <template #prepend-inner v-if="filtros.histogramas.length === 0">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>

          <div class="pb-3 pl-1 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Aplicação</div>

            <FiltrosAutocomplete
              v-model="filtros.aplicacao"
              :items="selects.aplicacao"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
            >
              <template #prepend-inner v-if="filtros.aplicacao.length === 0">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>
        </div>

        <div v-if="EXIBIR_FILTRO_PRODUTOS_FORA_LINHA" class="d-flex">
          <div class="pb-3 pr-2 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Status</div>

            <FiltrosAutocomplete
              v-model="filtros.status_ativo_fora_linha"
              :items="selects.status_ativo_fora_linha"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
            >
              <template #prepend-inner v-if="filtros.status_ativo_fora_linha.length === 0">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>
        </div>

        <template v-if="EXIBIR_COMPRA_POR_FILIAL">
          <DivisorComLegenda legenda="Flags de compra por múltiplas filiais" class="mb-4 mt-2" />

          <div class="d-flex align-center mb-4">
            <v-switch
              v-model="compra_multifilial.comprar_por_filial"
              hide-details
              :disabled="filtros.filiais.length > 0"
              color="#a71830"
            >
              <template #label>
                <span class="pl-2 text-truncate">Comprar por filial</span>
              </template>
            </v-switch>

            <v-switch
              v-if="!ocultar_considerar_estoque_grupo_na_compra_por_filial"
              v-model="compra_multifilial.considerar_estoque"
              :disabled="!compra_multifilial.comprar_por_filial || filtros.filiais.length > 0"
              hide-details
              color="#a71830"
              class="ml-3"
            >
              <template #label>
                <span class="pl-2">Considerar estoque do grupo</span>
              </template>
            </v-switch>
          </div>
        </template>

        <DivisorComLegenda legenda="Flags de compra dos produtos combinados" class="mb-4 mt-6" />

        <div class="d-flex align-center">
          <v-switch
            v-model="filtros.compra_produtos_combinados_ativa"
            hide-details
            color="#a71830"
            @click="filtros.compra_categorias_ativa = false"
          >
            <template #label>
              <span class="pl-2">Ativar compra dos produtos combinados</span>
            </template>
          </v-switch>
        </div>

        <DivisorComLegenda legenda="Flags visão por categorias" class="mb-4 mt-6" />

        <div class="d-flex align-center">
          <v-switch
            v-model="filtros.compra_categorias_ativa"
            hide-details
            color="#a71830"
            @click="filtros.compra_produtos_combinados_ativa = false"
          >
            <template #label>
              <span class="pl-2">Ativar compra dos produtos na visão por categorias</span>
            </template>
          </v-switch>
        </div>

        <FiltroExibirProdutosInativos v-model="filtros.exibir_produtos_inativos" />

        <div class="d-flex justify-end pt-1">
          <v-btn
            dark small
            color="#A51B32"
            v-text="'aplicar filtros'"
            class="ml-3"
            @click="aplicarFiltros"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FiltrosAutocomplete from "@/components/compra/ProdutosGerais/Filtros/FiltrosAutocomplete";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda";
import { mapGetters } from 'vuex';
import FiltroExibirProdutosInativos from "@/components/compra/ProdutosGerais/Filtros/FiltroExibirProdutosInativos.vue";
import api from "@/api/api";
import {logout} from "@/helpers";

export default {
  name: "FiltrosTelaComprasProdutosGerais",
  components: {
    FiltroExibirProdutosInativos,
    DivisorComLegenda,
    BlocoFiltrosPrincipais,
    FiltrosAutocomplete,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    autocomplete_dense: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    filtros: {
      grupos: [],
      filiais: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      linhas: [],
      compradores: [],
      fornecedores: [],
      marcas: [],
      status_compra: [],
      status_produto: [],
      histogramas: [],
      status_ativo_fora_linha: [],
      aplicacao: [],
      compra_produtos_combinados_ativa: false,
      compra_categorias_ativa: false,
      exibir_produtos_inativos: false,
    },
    compra_multifilial: {
      comprar_por_filial: localStorage.config_multifilial_distribuir_por_filial === 'S',
      considerar_estoque: localStorage.config_multifilial_distribuir_por_filial === 'S'
        && localStorage.config_multifilial_considerar_estoque_grupo === 'S'
    },
    selects: {
      status_compra: [
        { valor: 1, descricao: 'Itens a comprar' },
        { valor: 2, descricao: 'Itens em completar compra' },
        { valor: 3, descricao: 'Itens em trânsito' },
      ],
      status_produto: [
        { valor: 1, descricao: 'Excesso' },
        { valor: 2, descricao: 'Nível Adequado' },
        { valor: 3, descricao: 'Baixa exposição a ruptura' },
        { valor: 4, descricao: 'Elevada exposição a ruptura' },
        { valor: 5, descricao: 'Ruptura' },
      ],
      histogramas: [
        { valor: '0. Sem histórico de vendas', descricao: '0. Sem histórico de vendas' },
        { valor: '1. Até 1 mês sem vender', descricao: '1. Até 1 mês sem vender' },
        { valor: '2. De 1 a 2 meses sem vender', descricao: '2. De 1 a 2 meses sem vender' },
        { valor: '3. De 2 a 3 meses sem vender', descricao: '3. De 2 a 3 meses sem vender' },
        { valor: '4. De 3 a 6 meses sem vender', descricao: '4. De 3 a 6 meses sem vender' },
        { valor: '5. De 6 a 9 meses sem vender', descricao: '5. De 6 a 9 meses sem vender' },
        { valor: '6. De 9 a 12 meses sem vender', descricao: '6. De 9 a 12 meses sem vender' },
        { valor: '7. Acima de 12 meses sem vender', descricao: '7. Acima de 12 meses sem vender' },
      ],
      aplicacao: [
        { valor: 'PRODUTO_EM_ANALISE_POR_LOTES', descricao: '0. Produto em Análise por Lotes' },
        { valor: 'PRODUTO_EM_VENDA_FUTURA', descricao: '1. Produtos com Venda Futura' },
        { valor: 'PRODUTO_DE_BAIXA_MOVIMENTACAO', descricao: '2. Produtos de Baixa Movimentação' },
      ],
      status_ativo_fora_linha: [
        { valor: 'A', descricao: '1. Ativo' },
        { valor: 'FL', descricao: '2. Fora de Linha' }
      ],
    },
    ocultar_considerar_estoque_grupo_na_compra_por_filial: localStorage.ocultar_considerar_estoque_grupo_na_compra_por_filial === 'S',
  }),
  computed: {
    ...mapGetters({
      FILIAL_COMPRA: "usuario/getFilialCompras",
    }),
    EXIBIR_COMPRA_POR_FILIAL() {
      return localStorage.filial_compra === 'S';
    },
    DIALOG_ATIVO: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    FILTROS_STORE: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getFiltros'];
      },
      set: function (valor) {
        this.$store.dispatch('CompraProdutosGerais/setFiltros', valor);
      }
    },
    PRODUTO_SELECIONADO: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getProdutoSelecionado'];
      },
      set: function (valor) {
        return this.$store.dispatch('CompraProdutosGerais/setProdutoSelecionado', valor);
      }
    },
    EXIBIR_FILTRO_PRODUTOS_FORA_LINHA() {
      return localStorage.compras_exibir_filtro_fora_linha_tela_compras_fornecedor === 'S';
    }
  },
  watch: {
    DIALOG_ATIVO() {
      if (this.DIALOG_ATIVO) {
        this.compra_multifilial.comprar_por_filial = this.$store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'];
        this.compra_multifilial.considerar_estoque = this.$store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'];
      }
    },
    'compra_multifilial.comprar_por_filial': function (valor) {
      if (!valor) {
        this.compra_multifilial.considerar_estoque = false;
      }
    },
  },
  mounted() {
    this.filtros = {...this.FILTROS_STORE};
    this.selecionarGrupoComprasUsuario();
  },
  methods: {
    selecionarGrupoComprasUsuario() {
      if (localStorage.compras_exibir_grupo_compras_usuario !== 'S') {
        return;
      }

      api.get('grupo-compras-usuario')
        .then(resp => {
          if (!resp.data.grupo) {
            return;
          }

          this.filtros.grupos = [resp.data.grupo.id];
        })
        .catch(logout)
    },
    aplicarFiltros() {
      this.PRODUTO_SELECIONADO = {};
      this.DIALOG_ATIVO = false;
      this.FILTROS_STORE = {...this.filtros, pesquisa: this.FILTROS_STORE.pesquisa};

      if (this.compra_multifilial) {
        this.$store.dispatch('CompraDistribuidaPorFilial/set_distribuir_por_filial', this.compra_multifilial.comprar_por_filial);
        this.$store.dispatch('CompraDistribuidaPorFilial/set_considerar_estoque_grupo', this.compra_multifilial.considerar_estoque);
      }

      this.$emit('update:filtros', {});
    }
  }
}
</script>

<style scoped>

</style>
